import { createEntityAdapter, EntityAdapter, EntityState } from '@ngrx/entity';

import { comparerByAlphabet } from '@app/comparers';
import { User } from '@app/models/user';
import { UserActionsUnion, UserActionTypes } from '@core/actions/user.actions';
import { createFeatureSelector, createSelector } from '@ngrx/store';

export interface State extends EntityState<User> {
  loading: boolean;
  loaded: boolean;
  usersComexCountries: any;
}

export const adapter: EntityAdapter<User> = createEntityAdapter<User>({
  selectId: (user: User) => user.id,
  sortComparer: comparerByAlphabet('ASC', 'firstName')
});

export const INITIAL_STATE: State = adapter.getInitialState({
  loading: false,
  loaded: false,
  usersComexCountries: []
});

export function reducer(
  state: State = INITIAL_STATE,
  action: UserActionsUnion
) {
  switch (action.type) {
    case UserActionTypes.Load:
      return { ...state, loading: true };

    case UserActionTypes.LoadFail:
      return { ...state, loading: false };

    case UserActionTypes.LoadSuccess:
      return adapter.addAll(action.users, {
        ...state,
        loading: false,
        loaded: true
      });

    case UserActionTypes.AddOne:
      return adapter.addOne(action.user, state);

    case UserActionTypes.AddAll:
      return adapter.addAll(action.users, state);

    case UserActionTypes.FetchUsersByTypeSuccess:
      return {
        ...state,
        usersComexCountries: action.data
      };

    default:
      return state;
  }
}

export const getState = createFeatureSelector<State>('users');

export const {
  selectIds,
  selectEntities,
  selectAll,
  selectTotal
} = adapter.getSelectors();

export const selectLoaded = (state: State) => state.loaded;
export const selectLoading = (state: State) => state.loading;
export const getUsersComexCountries = createSelector(
  getState,
  state => state.usersComexCountries
);
